<template>
  <div class="main-contain">
    <div class="header-container">
      <div class="l-content">
        <a href="https://www.fanvil.com/">
          <p></p>
        </a>
      </div>
      <ul class="r-content" :style="{ fontSize: '16px' }">
        <li><a href="https://fanvil.com/"> Home</a></li>
        <li>
          Products
          <ul class="submenu">
            <li>
              LINKVIL Wireless UC Products<i class="el-icon-arrow-right"></i>
              <ul class="lastmenu">
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/190.html"
                    >CA400 All-in-one Wireless Conference Solution</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/188.html"
                    >W712 RoIP Gateway</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/189.html"
                    >W610W Portable Wi-Fi Phone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/119.html"
                    >W611W Portable WiFi Phone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/191.html"
                    >W710P DECT Phone System</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/192.html"
                    >CS20 Portable Speakerphone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/193.html"
                    >CS40 Conferencing Speakerphone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/linkvil/info/id/194.html"
                    >DB20-H All-in-one Phone Station</a
                  >
                </li>
              </ul>
            </li>
            <li>
              SIP Phones<i class="el-icon-arrow-right"></i>
              <ul class="lastmenu">
                <li>
                  <a href="https://fanvil.com/products/p1/a%20se/index.html"
                    >A Series Android Touch Screen IP Phone</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p1/v%20series%20ip%20phone/index.html"
                    >V Series High-end IP Phone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/p1/x/index.html"
                    >X Series IP Phone/Call Center Phone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/p1/xu/index.html"
                    >XU Series Business IP Phone</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/p1/x300/index.html"
                    >X300 Series Business IP Phone</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p1/h%20xiliejiudianhuaji/index.html"
                    >H Series Hotel IP Phone</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p1/ata%20gateway/index.html"
                    >ATA Gateway</a
                  >
                </li>
              </ul>
            </li>
            <li>
              SIP Security Industry Products<i class="el-icon-arrow-right"></i>
              <ul class="lastmenu">
                <li>
                  <a
                    href="https://fanvil.com/products/p5/i6%20series%20high-end%20video%20door%20phone/index.html"
                    >High-end Video Door Phone</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p5/sipshineiji/index.html"
                    >Indoor Station</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/p5/sipmenjin/index.html"
                    >Audio/Video Door Phone</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p5/sip%20duijiang2/index.html"
                    >Audio/Video Intercom</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p5/wulianwangwangguan_1/index.html"
                    >Audio/Video Gateway & Paging</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p5/sip%20speaker/index.html"
                    >SIP Speaker</a
                  >
                </li>
                <li>
                  <a
                    href="https://fanvil.com/products/p5/keshixunhutaihuaji/index.html"
                    >Console IP Phone</a
                  >
                </li>
              </ul>
            </li>
            <li>
              2-Wire Products<i class="el-icon-arrow-right"></i>
              <ul class="lastmenu">
                <li>
                  <a href="https://fanvil.com/products/2/2-wire/index.html"
                    >2-Wire Converter</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/2/2-wir/index.html"
                    >2-Wire PoE Switch</a
                  >
                </li>
                <li>
                  <a href="https://fanvil.com/products/2/2-wi/index.html"
                    >2-Wire IP Phone</a
                  >
                </li>
              </ul>
            </li>
            <li>
              <a
                href="https://fanvil.com/products/business%20conferencing_1/index.html"
                >Business Conferencing</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/products/headset/index.html"
                >Headset</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/products/fdms/index.html"
                >Service Platform</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/products/peijian/index.html"
                >Accessories</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/products/p8/index.html"
                >EOL Products</a
              >
            </li>
          </ul>
        </li>
        <li>
          Solutions
          <ul class="submenu">
            <li>
              <a href="https://fanvil.com/solution/CXSolution.html"
                >3CX Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/TeamsSolution.html"
                >Teams Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/ZoomSolution.html"
                >Zoom Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/Wire.html"
                >2-Wire Enterprise Office Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/SchoolSolution.html"
                >School Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/CloudSolution.html"
                >Cloud Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/DGH.html"
                >Community Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/MedicalSolution.html"
                >Medical Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/ApartmentSolution.html"
                >Apartment Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/StationSolution.html"
                >Station Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/parking.html"
                >Unmanned Parking Lots Solution</a
              >
            </li>
            <li>
              <a
                href="https://fanvil.com/solution/HighwayBroadcastandIntercomSolution.html"
                >Highway Broadcast & Intercom Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/IndustrialSolution.html"
                >Industrial Solution</a
              >
            </li>
            <li>
              <a
                href="https://fanvil.com/solution/SupermarketChainSolution.html"
                >Supermarket Chain Solution</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/solution/ScenicAreaSolution.html"
                >Scenic Area Solution</a
              >
            </li>
          </ul>
        </li>
        <li>
          Case Studies
          <ul class="submenu">
            <li>
              <a href="https://fanvil.com/case/index.html">Case Studies</a>
            </li>
            <li>
              <a href="https://fanvil.com/case/index.html?item=submityourcases"
                >Submit Your Cases</a
              >
            </li>
          </ul>
        </li>
        <li>
          Support
          <ul class="submenu">
            <li>
              <a href="https://fanvil.com/service/doc/index.html"
                >Download Center</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/service/help/index.html"
                >Help Center</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/service/security/index.html"
                >Security Center</a
              >
            </li>
            <!-- <li>
              <a href="https://kb.fanvil.com"
                >Knowledge Base</a
              >
            </li> -->
            <li>
              <a href="http://172.18.1.14:8080/"
                >Knowledge Base</a
              >
            </li>
          </ul>
        </li>
        <li>
          Partners
          <ul class="submenu">
            <li>
              <a href="https://fanvil.com/partners/reg.html"
                >Become a Partner</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/partners/techpartner/index.html"
                >Technology Partners</a
              >
            </li>
            <li>
              <a
                href="https://fanvil.com/login.aspx?redirect=%2fen%2fuser_center.aspx"
                >Partner Portal</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/partners/mappolicy.html"
                >MAP Policy</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/partners/networkcustomer.html"
                >Online Reseller Program</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/partners/search/index.aspx"
                >Find an Authorized Online Reseller</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/partners/blacklist.html"
                >Unauthorized Fanvil Online Reseller</a
              >
            </li>
            <li>
              <a
                href="https://fprs.fanvil.com.cn/en/login.aspx?frompath=/en/index.aspx"
                >FPRS Project Registration</a
              >
            </li>
            <li>
              <a href="https://academy.fanvil.com/User/Login"
                >Training & Certification</a
              >
            </li>
          </ul>
        </li>
        <li>
          Company
          <ul class="submenu">
            <li>
              <a href="https://fanvil.com/aboutus/2046.html">About Fanvil</a>
            </li>
            <li>
              <a href="https://fanvil.com/news/index.html">Company News</a>
            </li>
            <li>
              <a href="https://fanvil.com/active/index.html"
                >Marketing Activity</a
              >
            </li>
            <li>
              <a href="https://fanvil.com/contactus/index.html">Contact us</a>
            </li>
            <li>
              <a href="https://fanvil.com/blog/index.html">Blog</a>
            </li>
          </ul>
        </li>
        <li>
          <i
            class="el-icon-search"
            :style="{ fontSize: '20px' }"
            @click="openSearch"
          ></i>
        </li>
        <li>
          <div class="lang">
            <i style="width: 18px; height: 18px"></i>
            <em>EN</em>
            <!-- <img src="../assets/images/lang.png" alt="" /> -->
          </div>
          <!-- <ul class="submenu-lang">
            <li><a @click="changeLanguage('en')">EN</a></li>
            <li><a @click="changeLanguage('zh')">中文</a></li>
            <li><a @click="changeLanguage('')">한국어</a></li>
          </ul> -->
        </li>
      </ul>
    </div>

    <SearchDialog v-if="searchBtn" />
  </div>
</template>
<script>
import SearchDialog from "../components/SearchDialog.vue";

export default {
  components: {
    SearchDialog,
  },
  data() {
    return {};
  },
  computed: {
    searchBtn() {
      return this.$store.state.tab.searchBtn;
    },
  },
  methods: {
    changeLanguage(lang) {},
    openSearch() {
      this.$store.commit("openSearch");
    },
  },
};
</script>
<style lang="less" scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.418);
  width: 100%;
  box-shadow: 0 1px 2px -2px rgba(7, 59, 48, 0.12);

  .r-content {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-right: 12%;
    list-style: none;
    padding: 0;

    > li {
      margin: 0 25px;
      position: relative;

      a {
        width: 100%;
        text-decoration: none; /* 去除下划线 */
        color: #333;
        cursor: pointer;
        position: relative;
      }

      > i {
        position: relative;
        z-index: 99;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        z-index: 0;
      }

      &:hover > a,
      &:hover,
      .submenu > li:hover {
        color: red;
        cursor: pointer;
      }

      &:hover > .submenu,
      &:hover > .submenu-lang {
        display: block;
      }

      .el-icon-search {
        margin: 0 10px 0 10px;
      }

      .lang {
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          display: inline-block;
          margin-right: 5px;
          background: url(../assets/images/地球.png) center center / contain
            no-repeat;
        }

        em {
          font-style: normal;
          color: #333;
        }

        img {
          margin-left: 7px;
        }
      }
      // &:hover .lang > i {
      //   width: 19px;
      //   height: 19px;
      //   background: url(../assets/images/red-earth.png) center center / contain
      //     no-repeat;
      // }
    }

    >li:last-of-type {
      cursor: default;
    }


    .submenu {
      z-index: 99;
      font-size: 14px;
      display: none;
      color: #333;
      width: 230px;
      background-color: white;
      position: absolute;
      top: 55px;
      left: -70px;
      list-style: none;
      padding: 0 20px;
      border-radius: 5px;
      box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.15);

      > li {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
        border-bottom: 1px solid #c1c1c157;
        &:last-of-type {
          border: none;
        }
        &:hover > a {
          color: red;
          cursor: pointer;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          width: 260px;
          height: 47px;
        }

        &:hover > .lastmenu {
          display: block;
        }

        .lastmenu {
          font-size: 14px;
          display: none;
          color: #333;
          width: 300px;
          background-color: white;
          position: absolute;
          top: 0;
          left: 255px;
          list-style: none;
          padding: 0 18px;
          border-radius: 5px;
          box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.15);

          li {
            padding: 15px 0;
            border-bottom: 1px solid #c1c1c157;
            &:hover > a {
              color: red;
              cursor: pointer;
            }
            &:last-of-type {
              border: none;
            }
          }
        }
      }
    }

    .submenu-lang {
      font-size: 14px;
      display: none;
      color: #333;
      width: 100px;
      background-color: white;
      position: absolute;
      top: 55px;
      left: -30px;
      list-style: none;
      padding: 0 20px;
      border-radius: 5px;

      > li {
        padding: 15px 0;
        border-bottom: 1px solid #c1c1c157;
        text-align: center;

        &:hover > a {
          color: red;
        }
        &:last-of-type {
          border: none;
        }
      }
    }
  }

  .l-content {
    p {
      margin-left: 30px;
      width: 120px;
      height: 60px;
      background: url(../assets/images/logo.jpg) no-repeat 50% / cover;
    }
  }
}
</style>